import { Tab, Tabs } from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AgGridTable from "../utilities/AgGridTable";
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import customStyles from "app/shared-components/SelectCustomStyle";
import DialogBox from "../utilities/DialogBox";
import { UpperCaseTextCellEditor } from "../asset-types/TextCustomCellEditor";

function HsCode() {
  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.hscode}`;
  const gridRef = useRef();
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState();
  const perPage = 10;
  const [rowData, setRowData] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [snackState, setSnackState] = useState(false);
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [showDeleteRow, setShowDeleteRow] = useState(false);
  const [rowEvent, setRowEvent] = useState("");
  const navigate = useNavigate();

  const openDeleteDialog = () => {
    setShowDeleteRow(true);
  };

  const handleClose = () => {
    setShowDeleteRow(false);
  };

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "hsCode",
      cellEditor: UpperCaseTextCellEditor,
      enableRowGroup: true,
    },
    {
      field: "description",
      enableRowGroup: true,
    },
  ]);

  const getHSCode = async () => {
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      let hsCode = list.data?._embedded?.hsCodes;
      setRowData(hsCode);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    getHSCode();
  }, []);

  const handleCancel = () => {
    navigate("/logistics");
  };

  const onRowValueChanged = useCallback(
    async (event) => {
      let data = event.data;
      const model = {
        id: data.id ? data.id : null,
        description: data.description,
        hsCode: data.hsCode,
        rowIndex: event.node.rowIndex,
      };
      if (
        updateData.filter((doc) => doc.rowIndex === event.node.rowIndex)
          .length > 0
      ) {
        const updatedData = updateData.map((item) => {
          if (item.rowIndex === event.node.rowIndex) {
            item.description = data.description;
            item.code = data.hsCode;
          }
          return item;
        });
        setUpdateData(updatedData);
      } else {
        setUpdateData([...updateData, model]);
      }
    },
    [updateData]
  );

  const onGridReady = useCallback((params) => {
    setGridApi(params);
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
  }, []);

  const onBtAdd = useCallback((event) => {
    const newRow = {};
    const newRowDate = gridRef.current.api.applyTransaction({
      add: [newRow],
    });
    const RowIndex = newRowDate.add[0].rowIndex;
    // updateData.splice(RowIndex, 0, newRow);
    gridRef.current.api.refreshCells();

    setTimeout(() => {
      gridRef.current.api.setFocusedCell(RowIndex, "hsCode");
      gridRef.current.api.startEditingCell({
        rowIndex: RowIndex,
        colKey: "hsCode",
      });
    }, 800);
  }, []);
  const onBtStartEditing = useCallback((event) => {
    const index = event.node.rowIndex;
    gridRef.current.api.setFocusedCell(index, "hsCode");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "hsCode",
    });
  }, []);
  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = gridApi.api.getSelectedRows();
      rowData.splice(event.node.rowIndex, 1);
      gridRef?.current?.api.applyTransaction({ remove: selectedRow });
      selectedRow.map(async (row) => {
        if (row.id) {
          await OAuthService.deleteData(url, row.id);
        }
        handleClose();
      });
    },
    [gridApi, rowData, showDeleteRow]
  );

  const getContextMenuItems = (event) => {
    setRowEvent(event);
    var result = [
      {
        name: "Add Row",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          onBtAdd(event);
        },
      },
      {
        name: "Edit Row",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: () => {
          onBtStartEditing(event);
        },
      },
      {
        name: "Delete Row",
        // disabled: requireDocument.includes(data.documentName),
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          openDeleteDialog();
        },
      },
    ];
    return result;
  };

  const handleSubmit = async () => {
    setCheckSubmit(true);
    try {
      updateData.map(async (data) => {
        if (data.description && data.hsCode) {
          if (data.id) {
            await OAuthService.updateData(url, data.id, data);
            setSuccessMsg("Data Updated Successfully");
            setSnackState(true);
            setTimeout(() => {
              setSnackState(false);
            }, 2000);
          } else {
            await OAuthService.addData(url, data);
            setSuccessMsg("Data saved Successfully");
            setSnackState(true);
            setTimeout(() => {
              setSnackState(false);
            }, 2000);
          }
        } else {
          setSuccessMsg("Please fill all fields");
          setSnackState(true);
          setTimeout(() => {
            setSnackState(false);
          }, 2000);
        }
      });
    } catch (error) {
      setError(error.message);
      return;
    }
  };

  return (
    <>
      <div className="w-full h-full">
        <FormPageHeader
          componentName="Logistics HS Code"
          handleSubmit={handleSubmit}
          breadCrumbSeperator=">"
          successMsg={successMsg}
          snackState={snackState}
          currentPage={"Logistics HS Code"}
          parentBreadcrumbData={[
            { pageName: "Dashboard", pageLink: "/logistics" },
          ]}
          error={error}
          handleCancel={handleCancel}
        >
          <Tabs
            value={0}
            indicatorColor="secondary"
            textColor="secondary"
            variant="scrollable"
            scrollButtons="auto"
            classes={{ root: "w-full h-64 border-b-1" }}
          >
            <Tab className="h-64" label="Basic Info" />
          </Tabs>
        </FormPageHeader>
        <AgGridTable
          rowData={rowData}
          gridRef={gridRef}
          columnDefs={columnDefs}
          masterDetail={true}
          editable={true}
          editType={"fullRow"}
          getContextMenuItems={getContextMenuItems}
          onGridReady={onGridReady}
          onRowValueChanged={onRowValueChanged}
          // onSelectionChanged={onSelectionChanged}
        />
      </div>
      <DialogBox
        open={showDeleteRow}
        handleClose={handleClose}
        handleSumbit={() => onBtDeleteRow(rowEvent)}
        title={"remove HS Code"}
      />
    </>
  );
}

export default HsCode;
